import fetch from '../fetch';
import EndPoints from '../../data/EndPoints';
import Methods from '../../data/Methods';

export default () => {
	const headers = { 'content-type': 'application/json' };
	return fetch(Methods.PUT, EndPoints.POLICY_TERMS, { accepted: true }, headers, true);
};
